import {
  FormatAlignCenter,
  FormatAlignLeft,
  FormatAlignRight,
  KeyboardArrowDown,
  KeyboardArrowUp,
  KeyboardDoubleArrowDown,
  KeyboardDoubleArrowUp,
  VerticalAlignBottom,
  VerticalAlignCenter,
  VerticalAlignTop,
  type SvgIconComponent,
} from '@mui/icons-material';
import { i18n } from '~/lib/i18n';
import type { Direction, Position, StudioItem } from '../../context';

export const POSITIONS: Array<{ Icon: SvgIconComponent; value: Position }> = [
  { Icon: FormatAlignLeft, value: 'left' },
  { Icon: FormatAlignCenter, value: 'center' },
  { Icon: FormatAlignRight, value: 'right' },
  { Icon: VerticalAlignTop, value: 'top' },
  { Icon: VerticalAlignCenter, value: 'middle' },
  { Icon: VerticalAlignBottom, value: 'bottom' },
];

export const LAYERS: Array<{ Icon: SvgIconComponent; tooltip: string; value: Direction }> = [
  {
    Icon: KeyboardDoubleArrowUp,
    tooltip: i18n.t('pages.studio.edit.settings.position.move_front_tooltip'),
    value: 'front',
  },
  {
    Icon: KeyboardArrowUp,
    tooltip: i18n.t('pages.studio.edit.settings.position.move_forward_tooltip'),
    value: 'forward',
  },
  {
    Icon: KeyboardArrowDown,
    tooltip: i18n.t('pages.studio.edit.settings.position.move_backward_tooltip'),
    value: 'backward',
  },
  {
    Icon: KeyboardDoubleArrowDown,
    tooltip: i18n.t('pages.studio.edit.settings.position.move_back_tooltip'),
    value: 'back',
  },
];

const rotatePoint = ({ x, y }: { x: number; y: number }, degree: number) => {
  const cos = Math.cos(degree * (Math.PI / 180));
  const sin = Math.sin(degree * (Math.PI / 180));
  return { x: x * cos - y * sin, y: y * cos + x * sin };
};

export const rotateAroundCenter = (item: StudioItem, rotation: number) => {
  // Circle and RegularPolygon draw around x/y, so there is no top-left offset to correct.
  if (item.type === 'circle' || item.type === 'triangle') {
    return { rotation, x: item.x, y: item.y };
  }

  const topLeft = { x: -(item.width ?? 0) / 2, y: -(item.height ?? 0) / 2 };
  const current = rotatePoint(topLeft, item.rotation ?? 0);
  const rotated = rotatePoint(topLeft, rotation);
  const deltaX = rotated.x - current.x;
  const deltaY = rotated.y - current.y;

  return { rotation, x: Math.round(item.x + deltaX), y: Math.round(item.y + deltaY) };
};
